/* istanbul ignore file */

export var FREE_UK_DELIVERY = 'Free UK Delivery';
export var PRODUCT_OUT_OF_STOCK = 'Out of stock';
export var PRODUCT_UNAVAILABLE = 'No longer available';
export var NEW = 'New';